export const API_URLS = {
    USER_SEARCH_URL: '/user/search',
    USER_SAVE_URL: '/user/create',
    USER_UPDATE_URL: '/user/save',
    USER_ROLES: '/roles/allroles/',
    GET_SCHOOLS: '/credentialing/get-dentalschools',
    GET_SPECIALITY: '/credentialing/get-specialties',
    CREDENTIAL_SEARCH_URL: '/credentialing/search',
    CREDENTIAL_GET_URL : '/credentialing/get-data',
    VALIDATE_NPI_URL : '/validatenpi/search?number=',
    SAVE_DEMOGRAPHICS : '/credentialing/save-demographics',
    START_CREDENTIALING : '/credentialing/start-credentialing',
    SAVE_CREDENTIAL: '/credentialing/save-credential',
    SAVE_DOCUMENT: '/credentialing/save-document',
    SAVE_WORKHISTORY : '/credentialing/save-workhistory',
    SAVE_LOCATION : '/credentialing/save-location',
    GET_AZURE_DOCUMENT: '/credentialing/get-document',
    DELETE_DOCUMENTS: '/credentialing/delete-document',
    SAVE_ATTESTATIONS: '/credentialing/save-attestation',
    SAVE_DIRECTORY: '/credentialing/save-location-directory',
    TOKEN_URL: '/authorization/token',
    auth0Update: '/users/',
    AUTH_TOKEN: '/oauth/token',
    GET_USER_DETAIL : '/user/details',
    DELETE_CREDENTIALAPP : '/credentialing/delete',
    VALIDATE_DATA : '/validate-all-data',
    ATTESTATION_QUESTIONS: '/credentialing/get-attestation-questions',
    SUBMIT_CREDENTIAL_APPLICATION: '/overjet/submit',
    UPDATE_PROFILE: '/user/update-auth0',
    ERROR_LOG: '/telemetriclogs',
    GET_SCHOOLS_WITH_ADDRESSES: '/credentialing/get-dentalschools-address',
    WEB_TRAIL_LOG:'/log/webtrail',
    WEB_TRAIL_SEARCH:'/log/webtrailsearchcriteria',
    OVERJET_CREDENTALING_REQUEST_URL: '/overjet/credentialing-request',
    BENEFIT_PDF_URL: '/benefits/generatePdf',
    SEARCH_TIN : '/credentialing/provider-network/search',
    ADD_TIN : '/credentialing-transac/tin',
    SAVE_LOCATION_PAYEE_TAX: '/credentialing-transac/save-location-payee-tax',
    GET_W9_STATUS : '/credentialing/has-w9-mapping',
}